<script setup>
</script>
<template>
  <div id="app">
  <router-view />
  </div>
</template>

<style>
/* Global style to prevent text wrapping in all DataTable cells */
.p-datatable .p-datatable-tbody td {
  white-space: nowrap;
}
</style>
